import React from "react";
import { Link } from "react-router-dom";
import payment from "../asset/img/other/payment-visa-card.png";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";
import { ImLocation } from "react-icons/im";
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import { FaPhoneVolume } from "react-icons/fa6";

function Footer() {
  const currentYear = new Date().getFullYear();
  const tealGradient = "linear-gradient(135deg, #0d9488 0%, #115e59 100%)";

  return (
    <footer className="bg-slate-900 text-gray-300 pt-20 pb-10 overflow-hidden relative border-top border-dark">
      <div
        className="absolute top-0 left-0 w-full h-1"
        style={{ background: tealGradient }}
      ></div>

      <div className="container-fluid px-lg-5">
        <div className="row justify-content-between gy-5 mb-5 pb-5">
          {/* Brand Column */}
          <div className="col-lg-5 col-md-12">
            <div className="d-flex align-items-center gap-4 mb-4">
              <div
                className="logo-container bg-transparent p-0 rounded-0"
                style={{ width: "120px", height: "120px", minWidth: "120px" }}
              >
                <img
                  src="/logo3.png"
                  alt="Pulse Addis"
                  className="w-100 h-100 rounded-0"
                  style={{ objectFit: "contain" }}
                />
              </div>
              <div>
                <h2
                  className="text-white text-uppercase m-0 italic font-black"
                  style={{
                    fontSize: "3rem",
                    letterSpacing: "-2px",
                    fontWeight: "900",
                  }}
                >
                  PULSE <span className="text-info">ADDIS</span>
                </h2>
                <div
                  className="bg-info rounded-0 mt-2"
                  style={{ height: "5px", width: "80px" }}
                ></div>
              </div>
            </div>

            <p
              className="text-secondary fw-medium mb-4"
              style={{ fontSize: "16px", lineHeight: "1.8", maxWidth: "500px" }}
            >
              Your premium destination for healthcare excellence. We deliver
              certified medications, genuine medical supplies, and professional
              health consultation with a focus on quality and trust.
            </p>

            <div className="d-flex gap-3">
              {[FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn].map(
                (Icon, i) => (
                  <a
                    key={i}
                    href="#"
                    className="d-flex align-items-center justify-content-center border border-secondary text-secondary hover:text-info rounded-0"
                    style={{
                      width: "48px",
                      height: "48px",
                      backgroundColor: "transparent",
                      transition: "0.3s",
                    }}
                  >
                    <Icon size={20} />
                  </a>
                ),
              )}
            </div>
          </div>

          {/* Quick Menu */}
          <div className="col-lg-2 col-md-4">
            <h3
              className="text-white fw-bold mb-4 text-uppercase tracking-widest border-0 p-0"
              style={{ fontSize: "16px" }}
            >
              Explore
            </h3>
            <ul className="list-unstyled p-0 m-0">
              {[
                { label: "Prescriptions", path: "/prescription" },
                { label: "OTC Medicines", path: "/otc" },
                { label: "Vitamins", path: "/vitamins" },
                { label: "Medical Devices", path: "/shop" },
                { label: "Mother & Baby", path: "/mother-baby" },
              ].map(({ label, path }) => (
                <li key={label} className="mb-3">
                  <Link
                    to={path}
                    className="text-decoration-none text-secondary hover:text-info d-flex align-items-center gap-2"
                  >
                    <span
                      className="bg-info rounded-0"
                      style={{ width: "8px", height: "8px" }}
                    ></span>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section */}
          <div className="col-lg-4 col-md-8">
            <h3
              className="text-white fw-bold mb-4 text-uppercase tracking-widest border-0 p-0"
              style={{ fontSize: "16px" }}
            >
              Contact Us
            </h3>
            <div className="d-flex flex-column gap-4">
              <div className="d-flex align-items-start gap-4">
                <div className="text-info pt-1">
                  <ImLocation size={26} />
                </div>
                <div>
                  <small
                    className="text-secondary text-uppercase fw-black d-block mb-1"
                    style={{ fontSize: "10px", letterSpacing: "1.5px" }}
                  >
                    Location
                  </small>
                  <p className="m-0 text-white-50 fw-semibold">
                    Bole Sub-city, Addis Ababa, Ethiopia
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-center gap-4">
                <div className="text-info">
                  <FaPhoneVolume size={22} />
                </div>
                <div>
                  <small
                    className="text-secondary text-uppercase fw-black d-block mb-1"
                    style={{ fontSize: "10px", letterSpacing: "1.5px" }}
                  >
                    Support
                  </small>
                  <p className="m-0 text-white fw-bold">+251 924 888 811</p>
                </div>
              </div>

              <div className="d-flex align-items-center gap-4">
                <div className="text-info">
                  <MdOutlineMarkEmailUnread size={26} />
                </div>
                <div>
                  <small
                    className="text-secondary text-uppercase fw-black d-block mb-1"
                    style={{ fontSize: "10px", letterSpacing: "1.5px" }}
                  >
                    Email
                  </small>
                  <p className="m-0 text-white-50">contact@pulseaddis.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="bg-secondary opacity-25 my-5" />

        {/* Bottom Bar */}
        <div className="row align-items-center justify-content-between">
          <div className="col-md-6 mb-3 mb-md-0">
            <p className="small text-secondary fw-medium m-0">
              &copy; {currentYear}{" "}
              <span className="text-white fw-bold text-uppercase">
                Pulse Addis
              </span>
              . All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-md-end">
            <img
              src={payment}
              alt="Payment Methods"
              className="img-fluid"
              style={{ maxHeight: "30px" }}
            />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
